import moment, { Moment } from 'moment';

const DEFAULT_VISIBLE_MONTHS = 2;

export type AvailabilityRange = {
  start: Moment;
  end: Moment;
};

export const monthStart = (input?: string) => (input ? moment(input) : moment()).startOf('month');

export const rangeFor = (
  start: Moment,
  monthCount = DEFAULT_VISIBLE_MONTHS
): AvailabilityRange => ({
  start,
  end: start
    .clone()
    .add(monthCount - 1, 'month')
    .endOf('month'),
});

export const initialAvailabilityRange = (input?: string): AvailabilityRange =>
  rangeFor(monthStart(input));
